package provider

import androidx.compose.runtime.*
import common.frontend.api.*
import io.*
import io.ktor.util.*
import io.ktor.utils.io.core.*
import kotlinx.serialization.*
import srializable.*
import tk.mallumo.crypto.*

@Suppress("unused")
val LocalAccountProvider =
    staticCompositionLocalOf<CommonAccountProvider> { error("LocalAccountProvider is not implemented by CompositionLocalProvider") }

@OptIn(ExperimentalSerializationApi::class)
class CommonAccountProvider(
    account: Io.User?,
    credentials: Credentials?,
    private val onNewUser: (Io.User) -> Unit,
    private val onNewAuth: (Credentials) -> Unit,
    private val onLogout: () -> Unit
) {

    @Serializable
    data class Credentials(
        val username: String,
        val password: String
    )

    var current = account
        private set

    var auth = credentials
        private set

    suspend fun login(name: String, pass: String): Io.User? {
        current = Repository.api.user.login(name, pass)
            .also(onNewUser)
        auth = Credentials(name, pass)
            .also(onNewAuth)
        return current
    }

    fun confirmAccount(it: Io.User, name: String, pass: String) {
        current = it.also(onNewUser)
        auth = Credentials(name, pass)
            .also(onNewAuth)
    }

    fun logout() {
        current = null
        auth = null
        onLogout()
    }

    suspend fun reload(onSuccess: suspend (Io.User) -> Unit, onFail: suspend () -> Unit) {
        runCatching {
            current ?: error("invalid state")
            auth ?: error("invalid state")
            login(auth!!.username, auth!!.password)!!
        }.onFailure {
            logout()
            onFail()
        }.onSuccess {
            onSuccess(it)
        }
    }


    companion object {
        val key = "vevericka"
        val iv = ByteArray(16) {
            it.toByte()
        }

        inline fun <reified T> decrypt(nonce: String, input: String?): T? {
            input ?: return null
            return runCatching {
                AES.decryptAesCbc(input.decodeBase64Bytes(), "$nonce:$key".toByteArray(), iv, Padding.ZeroPadding)
                    .let { PROTO_INSTANCE.decodeFromByteArray<T>(it) }
            }.onFailure { it.printStackTrace() }
                .getOrNull()
        }

        inline fun <reified T> encrypt(nonce: String, input: T): String {
            return PROTO_INSTANCE.encodeToByteArray(input)
                .let {
                    AES.encryptAesCbc(it, "$nonce:$key".toByteArray(), iv, Padding.ZeroPadding)
                        .encodeBase64()
                }
        }
    }
}
